module.exports = new __parcel__URL__("C6O2.49ad4c31.jpg").toString();